import { render, staticRenderFns } from "./LocomotiveSmoothScrollPage.vue?vue&type=template&id=13888826&"
import script from "./LocomotiveSmoothScrollPage.vue?vue&type=script&lang=ts&"
export * from "./LocomotiveSmoothScrollPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports